import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_AUTH, ROUTE_LOGIN } from '@core/config/route-paths.config';
import { SessionService } from '@core/services/session.service';

export const authGuard: CanActivateFn = (route, state) => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!session.session || session.isSessionExpired()) {
    session.removeSession();
    return router.createUrlTree([`/${ROUTE_AUTH}/${ROUTE_LOGIN}`], {
      queryParams: { returnUrl: state.url },
    });
  }

  return true;
};
